import { getStateStore } from '../../stores';
// import { tempVideoState } from '../../stores/shared';
// import { setDesktopAudio } from '../peers/host';

const state = getStateStore('ipc');

const desktopAudioTracks: {
  [streamId: string]: MediaStreamTrack;
} = {};

export const initializeAudioStateEvents = () => {
  let cachedState = state.audioState.currentState;
  state.audioState.addListener(async (audioState) => {
    if (cachedState.desktopAudioMuted !== audioState.desktopAudioMuted) {
      console.debug('[Audio] State desktopAudioEnabled:', audioState.desktopAudioMuted);
    }
    const cachedSelectedMicId = cachedState.microphoneSources.find((source) => source.selected)?.deviceId;
    const selectedMicId = audioState.microphoneSources.find((source) => source.selected)?.deviceId;
    if (cachedSelectedMicId !== selectedMicId && selectedMicId !== undefined) {
      localStorage.setItem('selectedMicId', selectedMicId);
    }
    const cachedDesktopAudioSource = cachedState.desktopAudioSources.find((source) => source.selected)?.deviceId;
    const desktopAudioSource = audioState.desktopAudioSources.find((source) => source.selected)?.deviceId;
    if (cachedDesktopAudioSource !== desktopAudioSource && desktopAudioSource !== undefined) {
      console.debug('[Audio] State:', desktopAudioSource);
      localStorage.setItem('selectedDesktopAudioSource', desktopAudioSource);
    }
    // if (cachedState.desktopAudioSource !== audioState.desktopAudioSource) {
    //   console.debug('[Audio] State:', audioState.desktopAudioSource);
    //   if (!desktopAudioTracks[audioState.desktopAudioSource]) {
    //     // console.debug('[Audio] Getting desktop audio track:', audioState.desktopAudioSource);
    //     // const stream = (await (navigator.mediaDevices as any).getUserMedia({
    //     //   video: {
    //     //     mandatory: {
    //     //       chromeMediaSource: 'desktop',
    //     //       chromeMediaSourceId: audioState.desktopAudioSource,
    //     //     },
    //     //   },
    //     //   audio: {
    //     //     mandatory: {
    //     //       chromeMediaSource: 'system',
    //     //       chromeMediaSourceId: audioState.desktopAudioSource,
    //     //     },
    //     //   },
    //     // })) as MediaStream;
    //     // const audioTrack = stream.getAudioTracks()[0];
    //     // console.log('audioTrack', audioTrack);
    //   }
    // }
    cachedState = audioState;
  });
};
